export default __webpack_public_path__ + "static/media/Ping.07f41ebc.mp3";